<template>
  <nav class="c-navbar__nav"><slot /></nav>
</template>
<script>
import NavLink from "./NavLink.vue";

export { NavLink };
export default {};
</script>
